import * as ACTIONS from "../../Redux.constants";
import { endTour } from "./EndTour";
import { incrementTour } from "./IncrementTour";
import { startTour } from "./StartTour";

export function PageTourReducer(state, action) {
  switch (action.type) {
    case ACTIONS.START_TOUR:
      return startTour(state);
    case ACTIONS.INCREMENT_TOUR:
      return incrementTour(state);
    case ACTIONS.END_TOUR:
      return endTour(state);
    default:
      return state;
  }
}
